import { BaseAlgorithm } from './BaseAlgorithm';
import { CIDS } from '../../components/ProductsTable/constants';
import { debugLog, rankDebugLogEnable } from './ranking';

export class SmartSwitchAlgorithm extends BaseAlgorithm {
	constructor(usedFilters, filtersState) {
		super(usedFilters, filtersState);
		this.usedFilters = usedFilters;

		this.normVratedMin = 2;
		this.normIoutMin = 5;

		this.rankVratedMin = 0;
		this.rankIdrainMin = 0;

		this.weightVratedMin = 0.3;
		this.weightIdrainMin = 0.2;

		this.rV = 0;
		this.rI = 0;
	}
	logHeadingsToConsole() {
		if (rankDebugLogEnable) {
			console.log('partNumber,part_rI,rI,rankIdrainMin,part_rV,rV,rankVratedMin,feRank');
		}
	}

	execute(product) {
		debugLog.length = 0;
		debugLog.push(product[CIDS.PART_NUMBER]);
		// ---------------------------------------------Current Limit Typical  ILIM Typ at 25°C (A)-----------------------------------------------------

		[this.rankIdrainMin, this.rI] = this.calculateRankSingleSliderGTE(
			CIDS.TYPICAL_CURRENT_LIMIT_FOR_25_DEGREES,
			product,
			this.normIoutMin
		);

		// ---------------------------------------------Breakdown voltage  V(BR)DSS Min (V)-----------------------------------------------------

		[this.rankVratedMin, this.rV] = this.calculateRankSingleSliderGTE(
			CIDS.BREAKDOWN_VOLTAGE_DSS,
			product,
			this.normVratedMin
		);

		// -------------------------------------------------------------------------------------------

		let feRank = this.weightVratedMin * this.rankVratedMin + this.weightIdrainMin * this.rankIdrainMin;
		let isPunished = false;
		debugLog.push(feRank);

		[feRank, isPunished] = super.punishPartsWithNullValueOfUsedFilters(product, this.usedFilters, feRank);

		let finalRank = (1 - this.weightVratedMin - this.weightIdrainMin) * super.execute(product) + feRank;

		return isPunished ? finalRank / this.maxRankAfterPunish : finalRank;
	}
}
